"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = autoload;
/* eslint-disable @typescript-eslint/no-unsafe-return */
const Druid_1 = require("../../Druid");
const ViewFinder_1 = require("../../Framework/View/ViewFinder");
/**
 * Automatically start this view.
 * - search for [data-view] attribute for given View
 * - instantiate view
 *
 * Note: Autoload only initializes on page load.
 */
function autoload(constructor) {
    const finder = new ViewFinder_1.default(Druid_1.default.getViewFramework());
    document.addEventListener('DOMContentLoaded', () => finder.getView(document.body, constructor));
}
//# sourceMappingURL=Autoload.js.map